// --- Filters ---
export const FILTER_CONNECTOR = { and: 'and', or: 'or' } as const;

// --- Indicators ---
export const LIBRARY_DEFAULT_PAGE_SIZE = 10;
export const INDICATOR_TAG_TYPES = {
    connector: 'connector',
    metric: 'metric',
    dimension: 'dimension',
    filter: 'filter',
    title: 'title',
} as const;
export const INDICATOR_CARD_WIDTH = 525;
// An indicator card plus the side panel padding on both sides
export const SIDE_PANEL_WIDTH = `calc(min(25vw, ${INDICATOR_CARD_WIDTH}px) + 32px)`;

// --- AI assistant ---
export const AI_QUESTION_MAX_LENGTH = 500;
// Filter value the pipeline emits when the user has to pick the value in the query builder
export const AI_FILTER_VALUE_PLACEHOLDER = '__to_select__';
